import { TableColumn } from "components/UserManagement/interfaces"
import { useIntl } from "react-intl"

const COLUMNS_BASE = "phronesis.usermanagement.table."
const USERS_COLUMNS = "phronesis.usermanagement.users.table."
const ORGANIZATIONS_COLUMNS = "phronesis.usermanagement.organizations.table."

export const usersColumnsHeader = () => {
	const intl = useIntl()
	return [
		{
			name: intl.formatMessage({ id: USERS_COLUMNS + "email" }),
			alignment: "left",
			nameColumnSort: "email",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: USERS_COLUMNS + "first_name" }),
			alignment: "left",
			nameColumnSort: "firstName",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: USERS_COLUMNS + "last_name" }),
			alignment: "left",
			nameColumnSort: "lastName",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: USERS_COLUMNS + "roles" }),
			alignment: "left",
			nameColumnSort: "roles",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: USERS_COLUMNS + "organization" }),
			alignment: "left",
			nameColumnSort: "organization",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: COLUMNS_BASE + "actions" }),
			alignment: "left",
			nameColumnSort: "",
		},
	]
}

export const organizationsColumnsHeader = () => {
	const intl = useIntl()
	return [
		{
			name: intl.formatMessage({ id: ORGANIZATIONS_COLUMNS + "organization" }),
			alignment: "left",
			nameColumnSort: "name",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: ORGANIZATIONS_COLUMNS + "description" }),
			alignment: "left",
			nameColumnSort: "description",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: ORGANIZATIONS_COLUMNS + "plan" }),
			alignment: "left",
			nameColumnSort: "plans",
			hasSort: true,
		},
		{
			name: intl.formatMessage({ id: COLUMNS_BASE + "actions" }),
			alignment: "left",
			nameColumnSort: "",
		},
	]
}

export const getObject = (id: string, data: Record<string, any>) =>
	data.data.find((value: any) => value[id] === data.item[id])

export const getObjectData = (
	object: Record<string, any>,
	dataIndex: Array<string>
) => {
	let valueIter = object
	dataIndex.forEach((item) => {
		valueIter = valueIter[item]
	})
	return valueIter
}

export const mapData = (
	data: Array<any>,
	columns: Array<TableColumn>
): Array<any> => {
	const mapper = columns.map((item) => ({
		column: item.column,
		dataIndex: item.dataIndex.split("."),
	}))
	return data.map((item) => {
		const returnValue: Record<string, any> = {}
		mapper.forEach((obj) => {
			returnValue[obj.column] = getObjectData(item, obj.dataIndex)
		})
		return returnValue
	})
}

const searchIsOnValue = (value: any, search: string) => {
	if (typeof value == "string")
		return value.toLowerCase().includes(search.toLowerCase())
	if (typeof value == "object") {
		return value
			.map((item: string) => item.toLowerCase().includes(search.toLowerCase()))
			.reduce((prev: boolean, curr: boolean) => prev || curr)
	}
}

export const onFilter = (item: any, search: string): boolean => {
	const values = Object.values(item)
	return values
		.map((item) => searchIsOnValue(item, search))
		.reduce((prev, curr) => prev || curr)
}
